// Safe before RootLayoutApp: no stores, providers, translations or Sentry imports.
import * as Updates from 'expo-updates'
import { createOtaCoordinator } from './ota-coordinator'

export const otaClient = createOtaCoordinator(Updates)
